import { MechanicalAspectSearchComponentBase } from './mechanical-aspect-search.component.base';
import { ChangeDetectorRef, Component, Injector, Input, Optional, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatColumnDef, MatTable } from '@angular/material/table';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Columns, CrudRevisionEntity, FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { Asset, MechanicalAspect } from 'assets-model';
import { MechanicalAspectService, RefCodeStorage } from 'assets-service';


// @Component({
//   selector: 'app-mechanical-aspect-search',
//   templateUrl: './mechanical-aspect-search.component.html',
//   styleUrls: ['./mechanical-aspect-search.component.scss']
// })
export class MechanicalAspectSearchComponent extends MechanicalAspectSearchComponentBase {

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected mechanicalAspectService: MechanicalAspectService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(route, router, userStorage, dialog, mechanicalAspectService, refCodeStorage, fb, formStorage, injector);
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();

    if (!this.restoreFormFromParams(this.searchForm)) {
      this.resetSearchForm();
      this.restoreFormChanges();
    }
  }

  resetSearchForm() {
    // placeholder
  }

  protected transformParamsToModelSetters(params: Params): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    return this.transformAllPropertiesToModelSetters();
  }

}

@Component({
  selector: 'app-mechanical-aspect-search-result-columns',
  templateUrl: './mechanical-aspect-search-result-columns.component.html',
  styleUrls: ['./mechanical-aspect-search.component.scss']
})
export class MechanicalAspectSearchResultColumnsComponent {
  @ViewChildren(MatColumnDef) columnDefs: QueryList<MatColumnDef>;

  constructor(@Optional() public table: MatTable<any>, private cdRef: ChangeDetectorRef) { }

  @Input()
  columns: Columns;

  @Input()
  cellClassFn = (element: MechanicalAspect, fieldName: any, relationshipGetter?: (element: Asset) => any, previousRevisionGetter?: (record: CrudRevisionEntity) => CrudRevisionEntity) => { };

  @Input()
  assetGetter: (record: any) => Asset;

  @Input()
  mechanicalAspectGetter: (record: any) => MechanicalAspect;

  @Input()
  previousRevisionGetter: (record: CrudRevisionEntity) => CrudRevisionEntity


  ngOnInit() {
    if (!this.assetGetter) {
      this.assetGetter = (record: any) => record;
    }
    if (!this.mechanicalAspectGetter) {
      this.mechanicalAspectGetter = (record: any) => record?.mechanicalAspect;
    }

    if (this.table) {
      this.cdRef.detectChanges();
      this.columnDefs.forEach(columnDef => {
        this.table.addColumnDef(columnDef);
      });
    }
  }

  cellClass(element: MechanicalAspect, fieldName: string, relationshipGetter?: (element: Asset) => any, previousRevisionGetter?: (record: CrudRevisionEntity) => CrudRevisionEntity) {
    return this.cellClassFn(element, fieldName, relationshipGetter, previousRevisionGetter);
  }
}

